var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.32,
    height: 24.326,
    viewBox: "0 0 24.32 24.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 24.32,
    height: 24.326,
    transform: "translate(0 0)",
    fill: "#015c7e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_382",
    "data-name": "Groupe 382",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_363",
    "data-name": "Groupe 363",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2849",
    "data-name": "Trac\\xE9 2849",
    d: "M4.278,24.326c-.359-.088-.726-.149-1.075-.269a4.707,4.707,0,0,1-3.2-4.44Q-.006,12.16.009,4.7A4.728,4.728,0,0,1,4.7.01q3.656-.02,7.313,0a4.74,4.74,0,0,1,4.7,4.708c.009,1.2,0,2.391,0,3.586a.951.951,0,1,1-1.9,0c0-1.156,0-2.312,0-3.467A2.85,2.85,0,0,0,11.9,1.906q-3.538,0-7.076,0A2.849,2.849,0,0,0,1.9,4.817q0,7.35,0,14.7a2.849,2.849,0,0,0,2.9,2.907q3.562.006,7.123,0a2.849,2.849,0,0,0,2.9-2.907c0-1.18,0-2.359,0-3.539a.936.936,0,0,1,.728-.935.918.918,0,0,1,1.045.465,1.109,1.109,0,0,1,.12.475c.009,1.243.018,2.486,0,3.729a4.749,4.749,0,0,1-4.114,4.57,1.031,1.031,0,0,0-.156.044Z",
    transform: "translate(0 0)",
    fill: "#015c7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2850",
    "data-name": "Trac\\xE9 2850",
    d: "M43.622,33.6a5.011,5.011,0,0,1-.472.668c-.856.878-1.73,1.739-2.6,2.607a.96.96,0,0,1-.922.313.943.943,0,0,1-.5-1.577c.333-.36.691-.7,1.036-1.045.054-.054.1-.111.192-.206h-.317q-6.017,0-12.035,0a1.619,1.619,0,0,1-.4-.037.94.94,0,0,1-.7-1.019.955.955,0,0,1,.913-.841c.079,0,.158,0,.237,0H40.345c-.053-.067-.084-.116-.123-.155-.34-.342-.684-.681-1.023-1.025a.952.952,0,1,1,1.337-1.349c.926.92,1.851,1.841,2.765,2.774a2.723,2.723,0,0,1,.321.517Z",
    transform: "translate(-19.302 -21.24)",
    fill: "#015c7e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutIcon);
export default __webpack_public_path__ + "static/media/out-icon.572fc16a32bf4d9be2bd2009e647749b.svg";
export { ForwardRef as ReactComponent };